module.exports = __webpack_public_path__ + "static/media/stage_fright.4a4d945a.jpg";